const config = {
  ENVIRONMENT_NAME: 'prod',
  forwoodId: {
    URL: 'https://id.oceanagold.forwoodsafety.com',
    USER_TOKEN_URL: 'https://hjfncphl83.execute-api.ap-southeast-1.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'ap-southeast-1',
    URL: 'https://u12xcx2q8i.execute-api.ap-southeast-1.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'teams-container-1.11.7',
    HOSTNAME: 'https://teams.oceanagold.forwoodsafety.com',
    TEAMS_MICROFRONTEND_URL: 'https://teams-service.oceanagold.forwoodsafety.com',
    TARGETS_MICROFRONTEND_URL: 'https://targets.oceanagold.forwoodsafety.com',
    TEAMS_ACCESS_ROLE: 'TeamsAccess',
    TEAM_TARGETS_ACCESS_ROLE: 'TeamTargetsAccess',
  },
  configurationService: {
    URL: 'https://config.oceanagold.forwoodsafety.com',
    WEBSOCKET: 'wss://rtlm1yf763.execute-api.ap-southeast-1.amazonaws.com/prod'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
